<template>
    <div class="d-flex justify-center align-center mb-2">


        <div class="toolbar-center">
            <v-btn small @click="undo" :disabled="!canUndo">
                <v-icon>mdi-undo</v-icon>
            </v-btn>
            <v-btn small @click="redo" :disabled="!canRedo">
                <v-icon>mdi-redo</v-icon>
            </v-btn>

            <v-divider vertical class="mx-2"></v-divider>

            <v-btn small @click="clearAll" :disabled="blocks.length === 0" class="no-uppercase">
                <v-icon>mdi-delete-sweep</v-icon>
                Vider
            </v-btn>
        </div>


    </div>
</template>

<script>


export default {
    name: 'ContentBuilderToolbar',
    props: {
        blocks: {
            type: Array,
            default: () => []
        },
        history: {
            type: Object,
            default: () => ({ undo: [], redo: [] })
        }
    },
    data() {
        return {

        }
    },
    computed: {
        canUndo() {
            return this.history.undo.length > 0
        },
        canRedo() {
            return this.history.redo.length > 0
        }
    },
    methods: {
        undo() {
            this.$emit('undo')
        },
        redo() {
            this.$emit('redo')
        },
        clearAll() {
            if (confirm('Êtes-vous sûr de vouloir supprimer tous les blocs ?')) {
                this.$emit('clear-all')
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.content-builder-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: white;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 8px 8px 0 0;

    .toolbar-left,
    .toolbar-center,
    .toolbar-right {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .toolbar-center {
        flex: 1;
        justify-content: center;
    }

    .v-btn {
        text-transform: none;
        font-weight: 500;
    }

    .v-divider {
        height: 24px;
    }
}
</style>
